import { MyResourceRoutes } from './resources_routes';
import { MyPeopleDetailViewController } from './views/my_people_detail/my_people_detail_controller';
import { MyPeopleListController } from './views/my_people_list/my_people_list';
import { MyPlaceDetailViewController } from './views/my_place_detail/my_place_detail_controller';
import { MyPlacesListController } from './views/my_places_list/my_places_list';
import { MyResourcesComponent } from './views/my_resources/my_resources';

angular
  .module('my-resources', ['capability-ng-resources'])
  .component('myResources', new MyResourcesComponent())
  .controller('MyPlacesListController', MyPlacesListController)
  .controller('MyPlaceDetailViewController', MyPlaceDetailViewController)
  .controller('MyPeopleListController', MyPeopleListController)
  .controller('MyPeopleDetailViewController', MyPeopleDetailViewController)
  .config(MyResourceRoutes);



// WEBPACK FOOTER //
// ./app/lib/my_resources/my_resources_module.ts